<template>
  <div class="print-section">
    <ImageMedia
      v-if="hasMediaObject"
      class="print-section__image"
      :testId="imageTestId"
      :size="IMAGE_SIZES.THUMBNAIL"
      :src="mediaObject"
      :style="{
        height: `${imageHeight}px`,
      }"
    />
    <div
      class="print-section__content"
      :style="{ 'font-size': `${fontSize}px` }"
    >
      <div
        v-for="(question, index) in questions"
        :key="index"
        :data-testid="question.tid"
      >
        <template v-if="question.answer || question.icon">
          <p class="print-section__question mb-0">
            {{ question.text }}
          </p>
          <v-icon v-if="question.icon" :color="question.icon.color">{{
            question.icon.type
          }}</v-icon>
          <p
            class="print-section__answer"
            v-html="$sanitize(question.answer, { allowedTags: ['a'] })"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { IMAGE_SIZES } from 'rever-media-sdk'

import ImageMedia from '@/components/ImageMedia/ImageMedia.vue'

export default {
  name: 'EvidenceSection',

  components: {
    ImageMedia,
  },

  props: {
    mediaObject: {
      type: Object,
      required: false,
    },
    imageTestId: {
      type: String,
      required: false,
      default: 'print_image',
    },
    imageHeight: {
      type: String,
      required: false,
      default: '110',
    },
    questions: {
      type: Array,
      required: true,
    },
    fontSize: {
      type: String,
      required: false,
      default: '12',
    },
  },
  data() {
    return {
      photo: '',
      IMAGE_SIZES,
    }
  },
  computed: {
    hasMediaObject() {
      return Boolean(this.mediaObject?.id)
    },
  },
}
</script>

<style lang="scss" scoped>
.print-section {
  display: flex;

  &__image {
    width: 45%;
    border: 1px solid $color-blue-grey-lighten1;
    border-radius: 4px;
    margin-right: 12px;
  }

  &__content {
    flex: 1;
  }

  &__question {
    font-weight: bold;
    color: $color-blue-darken2;
    margin: 0;
  }

  &__answer {
    color: $color-blue-grey-darken3;
    margin-bottom: 8px;
  }
}
</style>
<style lang="scss">
@media screen, print {
  .print-section {
    i::before {
      color: $color-green !important;
    }
  }
}
</style>
